// eslint-disable-next-line no-restricted-imports
import { OrderResponseStateEnum } from '@eih-netbroker/api-order';

export const OrderState = OrderResponseStateEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type OrderState = (typeof OrderState)[keyof typeof OrderState];
